import EventScorekeepingAssignment from '@/screens/EventScorekeepingAssignment';

export default function PrivateEventEventIdScorekeepingAssignmentIndexRoute() {
  return <EventScorekeepingAssignment />;
}
